'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/DropDownCell/index.js');
var index$1 = require('../../atoms/Selectable/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var DropDown = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(DropDown, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(DropDown);

  function DropDown() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      direction: 'right'
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (event) {
      if (!_this.shouldCloseOnClick(event)) return;
      event.stopPropagation();

      _this.close();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (!_this.node.contains(event.target)) {
        event.preventDefault();
        event.stopPropagation();

        _this.close();
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleApply", function () {
      _this.props.onApply();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /* eslint-disable react/no-did-mount-set-state */
      document.addEventListener('click', this.handleClickOutside, true);
      var position = this.node.getBoundingClientRect();

      if (position.left < 0) {
        this.setState({
          direction: 'right'
        });
      } else if (position.right > window.innerWidth) {
        this.setState({
          direction: 'left'
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }, {
    key: "shouldCloseOnClick",
    value: function shouldCloseOnClick(event) {
      return this.props.closeOnClick && !this.props.multiple && this.node !== event.target;
    }
  }, {
    key: "close",
    value: function close() {
      this.props.onClose();
    }
  }, {
    key: "buildClassName",
    value: function buildClassName() {
      return ['ds-mol-dropdown', 'ds-mol-popover', "".concat(this.state.direction, "-direction"), this.props.className].join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React__default['default'].createElement("div", {
        ref: function ref(el) {
          _this2.node = el;
        },
        className: this.buildClassName(),
        onClick: this.handleClick,
        onKeyDown: this.handleClick,
        role: "button",
        tabIndex: 0
      }, this.props.children, this.props.multiple && /*#__PURE__*/React__default['default'].createElement(index, null, /*#__PURE__*/React__default['default'].createElement(index$1, {
        label: this.props.applyLabel,
        value: "apply",
        onSelect: this.handleApply,
        classNames: ['ds-atom-dialog-cell', 'multiple-apply']
      })));
    }
  }]);

  return DropDown;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(DropDown, "propTypes", {
  applyLabel: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node.isRequired,
  className: PropTypes__default['default'].string,
  multiple: PropTypes__default['default'].bool,

  /** Closes non multiple DropDowns when clicking a child */
  closeOnClick: PropTypes__default['default'].bool,
  onClose: PropTypes__default['default'].func,
  onApply: PropTypes__default['default'].func
});

_rollupPluginBabelHelpers.defineProperty(DropDown, "defaultProps", {
  applyLabel: 'Apply selection',
  className: '',
  multiple: false,
  closeOnClick: true,
  onClose: function onClose() {},
  onApply: function onApply() {}
});

module.exports = DropDown;
